import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class StrategiesAdd extends Component{
	render(){
		const {strategies} =this.props;
		let sc = _.find(strategies.permissions, (o) => {return o==='Create'});
		return (
			sc ?
				<p>
					<NavLink to={`/proigualdad/estrategias/crear`} className="button is-small is-inm-purple">{'Agregar estrategia'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(StrategiesAdd);


// WEBPACK FOOTER //
// ./src/elements/strategies/widget/strategies_add.jsx